import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab'
import search from "./search.js"
import common_variant from './common_variant'


Vue.use(Vuex);

// 创建vuex实例  modules模块拆分 export对外暴露
export default new Vuex.Store({
    modules: {
       tab,
       search, //搜索相关的全局变量等内容
       common_variant, //一些共用的变量
    }
})